import { AgentAvailability } from 'models/agent_status';
import ConversationItemType from 'models/conversation_item_type';
import { setAgentBusy } from 'actions/agent_status/lib/agent_status';
import SystemNotificationGenerator from 'scripts/domain/contracts/system_notification_generator';
import VerifyNewCustomer from 'actions/customer_match/verify_new_customer';

export default class AcceptIncomingCall {
  constructor(context) {
    this.context = context;
  }

  run() {
    let activeCall = this.context.stores.activeCall.get();
    if (!activeCall) {
      return;
    }

    if (!activeCall.customer.isVerified()) {
      this.context.executeAction(VerifyNewCustomer, {
        customerId: activeCall.customer.id,
      });
    }

    activeCall.setAgentHasAcceptedCall();
    this.context.stores.activeCall.set(activeCall);

    if (this.context.stores.agentStatus.get().getAvailability() !== AgentAvailability.BUSY) {
      setAgentBusy(this.context);
    }

    this.context.gateways.phoneGateway.accept();
    SystemNotificationGenerator.closeNotification(activeCall.conversationItem.id);

    this.context.analytics.track('Incoming Communication - Accepted', {
      contentType: ConversationItemType.PHONE_CALL,
      conversationItemId: activeCall.conversationItem.id,
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/phone_call/accept_incoming_call.js